import { request } from "./request";

export const apiLogin = (data = {}, config = {}) =>
  request("post", "/auth-cms/login", data, config);
